/** Distance-based nameplate LOD (tiles from camera focus). */

export const LABEL_NEAR = 18;
export const LABEL_FAR = 42;
/** Gather / bank / forge / skill-spot name pills. */
export const NODE_LABEL_NEAR = 14;
export const NODE_LABEL_FAR = 36;
/** Stationary NPC name pills (vendors, sitters, guides). */
export const NPC_LABEL_NEAR = 16;
export const NPC_LABEL_FAR = 40;
/** Travel pads / zone signs. */
export const PAD_LABEL_NEAR = 20;
export const PAD_LABEL_FAR = 48;
/** Floating interact icons (bank / forge / vendors / gather). */
export const SHOP_ICO_NEAR = 22;
export const SHOP_ICO_FAR = 52;

export function labelLod(
  distance: number,
  near = LABEL_NEAR,
  far = LABEL_FAR,
): { opacity: number; scale: number; visible: boolean } {
  if (distance >= far) {
    return { opacity: 0, scale: 0.72, visible: false };
  }
  if (distance <= near) {
    return { opacity: 1, scale: 1, visible: true };
  }
  const t = (distance - near) / (far - near);
  return {
    opacity: 1 - t,
    scale: 1 - t * 0.28,
    visible: true,
  };
}

export function applyLabelLod(
  el: HTMLElement,
  distance: number,
  opts?: { near?: number; far?: number; always?: boolean; preserveTransform?: boolean },
): void {
  if (opts?.always) {
    el.hidden = false;
    el.style.opacity = "1";
    if (!opts.preserveTransform) {
      el.style.transform = "translate(-50%, -100%) scale(1)";
    }
    return;
  }
  const lod = labelLod(distance, opts?.near, opts?.far);
  el.hidden = !lod.visible;
  if (!lod.visible) {
    return;
  }
  el.style.opacity = String(lod.opacity);
  // Shop-ico bob keyframes own transform; don't overwrite every frame.
  if (!opts?.preserveTransform) {
    el.style.transform = `translate(-50%, -100%) scale(${lod.scale.toFixed(3)})`;
  }
}
